export default __webpack_public_path__ + "static/media/sliderHorizontal.9a3937db.svg";